import CareerModel from './careermodel';

const TeamModel = CareerModel.extend({
  idAttribute: 'teamMemberID',
  initialize() {
    CareerModel.prototype.initialize.call(this);
  }
});

export default TeamModel;
